var _circle, _path, _line;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProductDisable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "none",
    stroke: "#757575"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98779 8.64722H17.5727C18.1833 8.64722 18.6787 9.14259 18.6787 9.75317V11.5964C18.6787 11.7992 18.5128 11.9651 18.31 11.9651H17.9414V18.2322C17.9414 18.64 17.6119 18.9695 17.2041 18.9695H8.35644C7.94862 18.9695 7.61914 18.64 7.61914 18.2322V11.9651H7.25049C7.04773 11.9651 6.88184 11.7992 6.88184 11.5964V9.75317C6.88184 9.14259 7.37721 8.64722 7.98779 8.64722ZM8.72564 17.8634H16.836V11.965H8.72564V17.8634ZM17.5728 10.8592H7.98782V9.7532H17.5728V10.8592ZM13.9785 14.1771H11.5823C11.4302 14.1771 11.3058 14.0527 11.3058 13.9006V13.3476C11.3058 13.1956 11.4302 13.0712 11.5823 13.0712H13.9785C14.1306 13.0712 14.255 13.1956 14.255 13.3476V13.9006C14.255 14.0527 14.1306 14.1771 13.9785 14.1771Z",
    fill: "#757575"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.32903,
    y1: 21.4941,
    x2: 22.5185,
    y2: 5.42498,
    stroke: "#757575",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductDisable);
export default __webpack_public_path__ + "static/media/Icon_product_disable.6276a5d6.svg";
export { ForwardRef as ReactComponent };